module.exports = __webpack_public_path__ + "static/media/innisfree-logo-2.c0bbabd8.jpg";